import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Form } from '@entrata/portals-common/lib/components/forms'
import { TextAreaField } from '@entrata/portals-common/lib/boxed-fields'
import ActionModal from './ActionModal'
import styled from '@emotion/styled'
import { SettingsListItem } from 'portal-modules/common/components/settings-list'
import Api from 'portal-modules/classifieds/api'
import { connect } from 'react-redux'

const StyledAdContainer = styled('div')`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
`

const StyledAdDetails = styled('div')`
  display: flex;
  flex-direction: column;
`

const StyledAdImage = styled('img')`
  width: 80px;
  height: 80px;
  margin: 16px;
`

const StyledAdAmount = styled('span')`
  color: red; /* TODO: set this to the right color */
`

const StyledAdTitle = styled('span')``

const StyledAdSeller = styled('span')`
  font-style: italic;
`

const ClassifiedSendMessageModal = props => {
  const handleSubmit = () => {
    // TODO: Send the message

    // props.onSubmit(values)
    props.onClose()
  }

  const initialFieldState = {
    message: { required: true, value: '' },
    include_email: { required: false, value: 1 },
    include_cell: { required: false, value: 1 },
  }

  const classifiedAttachments = props.classified_attachments
  const imageUrl =
    classifiedAttachments && classifiedAttachments.length
      ? props.classified_attachments[0].image_url
      : null

  return (
    <ActionModal title={__('Message the Seller')} {...props}>
      {() => (
        <Fragment>
          <StyledAdContainer>
            <StyledAdImage src={imageUrl} />
            <StyledAdDetails>
              <StyledAdAmount>{props.amount}</StyledAdAmount>
              <StyledAdTitle>{props.title}</StyledAdTitle>
              <StyledAdSeller>{props.customer_name}</StyledAdSeller>
            </StyledAdDetails>
          </StyledAdContainer>
          <Form onSubmit={handleSubmit} initialFieldState={initialFieldState}>
            <Form.Field id='message' name='message'>
              {fieldProps => (
                <TextAreaField
                  {...fieldProps}
                  label={__('Message to Seller')}
                />
              )}
            </Form.Field>
            <Form.Field id='include_email' name='include_email'>
              {fieldProps => (
                <SettingsListItem
                  {...fieldProps}
                  label={__('Include my email')}
                />
              )}
            </Form.Field>
            <Form.Field id='include_cell' name='include_cell'>
              {fieldProps => (
                <SettingsListItem
                  {...fieldProps}
                  label={__('Include my cell phone')}
                />
              )}
            </Form.Field>
            <Form.Actions
              render={() => (
                <ActionModal.Button title={__('SEND MESSAGE')} type='submit'>
                  {__('SEND MESSAGE')}
                </ActionModal.Button>
              )}
            />
          </Form>
        </Fragment>
      )}
    </ActionModal>
  )
}

ClassifiedSendMessageModal.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  seller: PropTypes.string,
  image: PropTypes.string,
  details: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  classified_attachments: PropTypes.array,
  customer_name: PropTypes.string,
  user_token: PropTypes.string,
}

export default connect(({user})=> ({user_token: user?.token}))(ClassifiedSendMessageModal)
